
export const filterOptions = [
    {value: 0, label: "All"},
    {value: 1, label: "Draft"},
    {value: 2, label: "Published"},
]


  